import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, AppleIcon, StethoscopeIcon, Gift } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: BookOpenIcon,
    badge: '🌱 EDUCACIÓN',
    badgeBg: '#e8f5e0',
    badgeColor: '#2d5a1b',
    href: '/solicitar-ayuda',
    title: 'Beca Semilla',
    description: 'Educación para padres, recursos, talleres y programas de formación para fortalecer el conocimiento familiar',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400'
  }, {
    icon: AppleIcon,
    badge: '💚 SALUD',
    badgeBg: '#e8f5e0',
    badgeColor: '#2d5a1b',
    href: '/solicitar-ayuda',
    title: 'Beca Crecer',
    description: 'Acceso a consultas con especialistas, evaluaciones, estudios complementarios y segundas opiniones',
    image: 'https://cdn.magicpatterns.com/uploads/oaPED5B4LsCjnQWb9Gp6fp/ChatGPT_Image_Jul_28,_2026,_12_59_18_PM.png'
  }, {
    icon: StethoscopeIcon,
    badge: '🤝 COMUNIDAD',
    badgeBg: '#e8f5e0',
    badgeColor: '#2d5a1b',
    href: '/solicitar-ayuda',
    title: 'Alianzas Estratégicas',
    description: 'Trabajo conjunto con médicos, terapeutas y organizaciones para ampliar el acceso a servicios de calidad',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400'
  }, {
    icon: Gift,
    badge: 'EMERGENCIAS',
    badgeBg: '#ffeeee',
    badgeColor: '#CC0000',
    href: '/venezuela-emergencia',
    title: 'Ayuda Humanitaria',
    description: 'Recolección de artículos de primera necesidad para familias afectadas por la emergencia en Venezuela.',
    image: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=400'
  }];
  return <section className="mp-becas-section" style={{
    background: 'linear-gradient(180deg, #f0fae8 0%, white 100%)',
    padding: '80px 20px'
  }} data-id="element-240" data-mp="bsh648sm6hos">
      <div className="max-w-6xl mx-auto" data-id="element-241" data-mp="2cxck4vc805fa">
        <p style={{
        color: '#7DC920',
        fontSize: '12px',
        letterSpacing: '3px',
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: '8px'
      }} data-id="element-242" data-mp="27xq64jokil5f">
          NUESTROS PROGRAMAS
        </p>
        <h2 className="mp-becas-title" style={{
        fontSize: '38px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        marginBottom: '12px'
      }} data-id="element-243" data-mp="2hu31dlzrh72a">
          Becas y Programas de Apoyo
        </h2>
        <p style={{
        fontSize: '16px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '48px',
        maxWidth: '640px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }} data-id="element-244" data-mp="35j4evnngb8ef">
          Diseñados para eliminar las barreras económicas que enfrentan las
          familias con niños neurodiversos
        </p>
        <div className="mp-becas-grid grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-245" data-mp="3hy2h71dh1pqt">
          {features.map(feature => <div key={feature.title} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" style={{
          borderTop: '4px solid #7DC920'
        }} data-id="element-246" data-mp="386g7j9gs7yq6">
              <img src={feature.image} alt={feature.title} className="w-full h-[180px] object-cover" data-id="element-247" data-mp="3441p2qh0z0zf" />
              <div className="p-6" data-id="element-248" data-mp="2p8vgbvqjoo2e">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-5" data-id="element-249" data-mp="2u5vms7rb3su1">
                  <feature.icon className="w-7 h-7 text-primary" data-id="element-250" data-mp="nffpaxqjp76w" />
                </div>
                <div style={{
              background: feature.badgeBg,
              color: feature.badgeColor,
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '2px',
              padding: '4px 10px',
              borderRadius: '20px',
              display: 'inline-block',
              marginBottom: '8px'
            }} data-id="element-251" data-mp="sfai56tvs6ul">
                  {feature.badge}
                </div>
                <h3 className="text-lg text-dark mb-3" style={{
              fontWeight: 800
            }} data-id="element-252" data-mp="25k2u6izhkh0l">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-253" data-mp="1womw1prp7fp7">
                  {feature.description}
                </p>
                <Link to={feature.href} style={{
              color: '#7DC920',
              fontWeight: 600,
              fontSize: '14px',
              textDecoration: 'none'
            }} data-id="element-254" data-mp="1msjvgochvp4d">
                  Conocer más →
                </Link>
              </div>
            </div>)}
        </div>

        <div className="mp-becas-box" style={{
        background: '#2d5a1b',
        borderRadius: '16px',
        padding: '32px 40px',
        maxWidth: '800px',
        margin: '40px auto 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px'
      }} data-id="element-255" data-mp="1cqft9vxqpw7t">
          <div data-id="element-256" data-mp="tvshsfj7x09b">
            <p style={{
            fontSize: '22px',
            fontWeight: 700,
            color: 'white',
            marginBottom: '6px'
          }} data-id="element-257" data-mp="yxhv61twxq0k">
              ¿Tu familia necesita apoyo?
            </p>
            <p style={{
            fontSize: '14px',
            color: 'rgba(255,255,255,0.8)'
          }} data-id="element-258" data-mp="68amwb4npm24">
              Estamos construyendo nuestro programa oficial de becas.
            </p>
          </div>
          <Link to="/solicitar-ayuda" className="mp-becas-box-btn" style={{
          background: '#7DC920',
          color: 'white',
          fontWeight: 700,
          padding: '14px 28px',
          borderRadius: '10px',
          whiteSpace: 'nowrap',
          textDecoration: 'none'
        }} data-id="element-259" data-mp="3udsbo81626ie">
            Solicitar Ayuda →
          </Link>
        </div>

        <div className="text-center" style={{
        marginTop: '40px'
      }} data-id="element-260" data-mp="3bg7p57lvjk0y">
          <p className="text-2xl font-bold text-dark max-w-3xl mx-auto" data-id="element-261" data-mp="3qcoy5s6lcmkc">
            Becas, alianzas y apoyo financiero para que ninguna familia quede
            sola.
          </p>
        </div>
      </div>
    </section>;
}